import React, { useCallback, useEffect, useState } from 'react'
import axios from 'axios'
import { useSelector } from 'react-redux'
import ModalMeerInfo from '../modal/modalMeerInfo'
import { API_URL } from '../../environment'

const MoreInfoButton = (props) => {
  const [labelText, setLabelText] = useState('')
  const { desktop, phone, modalData, answerSetKey } = props
  const { isLoading } = useSelector((state) => state.questionnaire)
  const [showModal, setShowModal] = useState(false)
  const {
    title,
    content,
    subtitle,
    subcontent,
    linkText,
    linkUrl,
    buttonText,
  } = modalData[answerSetKey]

  const handleShowModal = () => {
    setShowModal(!showModal)
  }
  const handleHideModal = () => {
    setShowModal(!showModal)
  }

  const escFunction = useCallback((event) => {
    if (event.keyCode === 27) {
      setShowModal(false)
    }
  }, [])

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false)

    return () => {
      document.removeEventListener('keydown', escFunction, false)
    }
  }, [escFunction])

  const getLabelText = useCallback(() => {
    
    axios
      // .get(API_URL + `/page/3`)
      .get(API_URL + `/page/67552c0a-0884-11ef-af54-024264400007`)
      .then((response) => {
        setLabelText(response?.data[0]?.pageContent.filter(data=>data.key==="more_info_text")[0])
      })
  }, [])

  useEffect(() => {
    getLabelText()
  }, [getLabelText])

  return (
    <>
      {showModal && (
        <ModalMeerInfo
          modalTitle={title}
          modalContent={content}
          modalSubTitle={subtitle}
          modalSubContent={subcontent}
          modalLinkText={linkText}
          modalLinkURL={linkUrl}
          modalBtnText={buttonText}
          show={showModal}
          handleHideModal={handleHideModal}
        />
      )}
      {desktop && (
        <button
          onClick={() => handleShowModal()}
          type="button"
          className="button button-secondary button-large"
          aria-controls="modal-meerInfo"
          aria-expanded="false"
        >
          {labelText ? labelText.value : ''}
        </button>
      )}
      {!isLoading && phone && (
        <button
          onClick={() => handleShowModal()}
          type="button"
          className="button button-primary button-block button-large external-button"
          aria-controls="modal-meerInfo"
          aria-expanded="false"
        >
          {labelText ? labelText.value : ''}
        </button>
      )}
    </>
  )
}
export default MoreInfoButton
